const resume = {
  iframeTitle: 'Eduard Hvizdak Resume',
  downloadCv: 'Download CV',
  openNewTab: 'Open in new tab',
};

export default resume;
